/**
 * @desc: 受理复核
 * @created: 2020/5/6
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http';
import qs from 'qs';

// 获取条件查询列表
export const getListData = params => {
  return request.get('/acceptanceReview/queryList', params)
}

// 以档案号获取供应商信息
export const getSupplierDetail = params => {
  return request.get('/acceptanceReview/getSupplierDetail', params)
}

// 企业工商信息
export const getCompanyInfo = params => {
  return request.get('/acceptanceReview/getCompanyInfo', params)
}

// 负责人信息
export const getPrincipalInfo = params => {
  return request.get('/acceptanceReview/principalInfo', params)
}

// 转移到供应商注册
export const transferToRegistered = data => {
  return request.post('/acceptanceReview/auditOpinion', qs.stringify(data))
}

// 批量通过
export const auditOpinionList = data => {
  return request.post('/acceptanceReview/auditOpinionList ', qs.stringify(data))
}

// 详情 => 历史记录
export const supplierHistory = params => {
  return request.get('/acceptanceReview/supplierHistory', params)
}

// 疑似关联
export const getSuspectedAssociationInfo = params => {
  return request.get('/acceptanceReview/getSuspectedAssociationInfo', params)
}